import {Tooltip, Modal} from 'bootstrap/js/index.esm';
import {customGa} from "./ga-custom";
import favoritesFn from "./favorites-fn";
import {errorMsgs} from "./error-handler";

const bootstrapVersion = Tooltip.VERSION;

export const isMobileDevice = (a => /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i
    .test(a.substring(0, 4)))(navigator.userAgent || navigator.vendor || window.opera);
export const isFavoritesPage = window.location.pathname === '/favorites';
export const supportsHistoryState = (typeof history == 'object' && typeof history.pushState == 'function' && typeof history.replaceState == 'function');

const filterModalElement = document.querySelector('#filterModal');
window.filterModal = filterModalElement ? new Modal(document.querySelector('#filterModal')) : undefined;

let hasLazyCSS = false;
export function downloadLazyCSS() {
    if(hasLazyCSS) return;

    const style = document.createElement('link');
    // noinspection JSUnresolvedReference
    style.href = '/dist/lazy.min.css';
    style.type = 'text/css';
    style.rel = 'stylesheet';
    document.head.append(style);

    hasLazyCSS = true;
}
/* MENU */

window.pushMenu = pushMenu;
export async function pushMenu() {
    await prepareMenuMobile();

    downloadMenuImages();
    initUserInfo();

    document.body.style.overflow = 'hidden';
    document.querySelector('#mainMenuCollapse').classList.add('show');

    const backdrop = document.createElement('div');
    backdrop.className = 'custom-backdrop';
    backdrop.onclick = () => pullMenu();

    document.querySelector('.navbar').appendChild(backdrop);
}

/* Ficha */
let imagesDownloaded = false;
function downloadMenuImages() {
    if(imagesDownloaded) return;

    document.querySelectorAll('.menu-image img[data-src]')
        .forEach(menuImage => {
            if(menuImage.hasAttribute('data-src')) {
                menuImage.setAttribute('src', menuImage.getAttribute('data-src'));
                if(!iOS()) menuImage.removeAttribute('data-src');
            }
        });

    imagesDownloaded = true;
}

window.pullMenu = pullMenu;
function pullMenu() {
    document.body.style.overflow = "auto";
    document.querySelector('#mainMenuCollapse').classList.remove('show');

    if(!window.location.href.includes('/privada')) menuChangeStep(1);
    else if(window.location.href.includes('/privada')) menuChangeStep(2);

    const backdrop = document.querySelector('.custom-backdrop');
    if(backdrop) backdrop.remove();
}

function loadMenuStep(cities, estadoId, estadoNombre, prevStep) {
    document.querySelectorAll('.menu-step[data-step="4"] ul')
        .forEach(element => element.remove());

    document.querySelector('.menu-step[data-step="4"] span.type-title span.city-label')
        .innerHTML = estadoNombre;

    const ul = document.createElement('ul');
    cities.forEach(async (city) => {
        let li = document.createElement('li');
        li.className = city.className;
        li.style.order = city.order;

        let cityHref = document.createElement('a');
        cityHref.href = `${document.location.protocol}//${document.location.hostname}/${city.path}`;
        cityHref.innerHTML = city.ciudad_nombre;
        cityHref.style.order = '0';

        if(city.areas.length > 0) {
            let areaTitle = document.createElement('span');
            translate({str: 'Areas', element: areaTitle});
            areaTitle.className = 'areas-title placeholder';
            areaTitle.style.order = '1';

            li.appendChild(areaTitle);
        }

        city.areas.forEach(area => {
            let areaHref = document.createElement('a');
            areaHref.href = `${document.location.protocol}//${document.location.hostname}/${area.path}`;
            areaHref.innerHTML = area.area_nombre;
            areaHref.className = area.className;
            areaHref.style.order = `${parseInt(area.order) + 1}`;

            li.append(areaHref);
        });

        li.appendChild(cityHref);
        ul.appendChild(li);
    });

    insertMasCidadesMenuStep(ul).then();

    if(window.tipologia === 'travestis')
        prevStep = prevStep +1;

    document.querySelector('.menu-step[data-step="4"]').appendChild(ul);
    const spanTitle = document.querySelector('.menu-step[data-step="4"] span.type-title');
    spanTitle.removeEventListener('click', () => menuChangeStep(prevStep));
    spanTitle.addEventListener('click', () => menuChangeStep(prevStep));

    menuChangeStep(4);
}

async function insertMasCidadesMenuStep(container) {
    let li = document.createElement('li');
    let a = document.createElement('a');

    a.href = window.location.origin + (window.tipologia === 'travestis' ? '/' : '/travestis');
    translate({str: '+ Mais cidades', element: a});
    a.style.color = '#1fb784';
    a.className = 'placeholder';

    li.style.order = '99999';

    li.appendChild(a);
    container.appendChild(li);
}

function getHomeUrl(revertEnd) {
    let end;
    if(revertEnd)
        end = window.tipologia === 'acompanhantes' ? 'travestis' : '';
    else
        end = window.tipologia === 'acompanhantes' ? '' : 'travestis';

    return document.location.protocol + "//" + document.location.hostname  + "/" + end;
}

window.menuChangeStep = menuChangeStep;
export function menuChangeStep(step) {
    const steps = Object.values(document.querySelectorAll('.menu-step'));
    document.querySelectorAll('.menu-step').forEach(menuStep => menuStep.classList.remove('last'));
    document.querySelectorAll('.menu-step.active').forEach(menuStep => menuStep.classList.add('last'));
    
    menuChangeFixScrollHeight(step);

    if(step !== 1) document.querySelector('#mainMenuCollapse').classList.add('scroll');
    else document.querySelector('#mainMenuCollapse').classList.remove('scroll');

    steps.find((item) => {
        let stepInt = parseInt(item.getAttribute('data-step'));
        if(!stepInt) return;

        item.classList.remove('active');

        if(stepInt === step) {
            item.classList.add('active');
        }
        else if(stepInt > step) {
            item.classList.add('pre');
            item.classList.remove('back', 'active');
        }
        else if(stepInt < step) {
            item.classList.add('back');
            item.classList.remove('pre', 'active');
        }
    });
}

function menuChangeFixScrollHeight(step) {
    const stepTwo = document.querySelector('.menu-step[data-step="2"] ul');
    const stepThree = document.querySelector('.menu-step[data-step="3"] ul');

    if(stepTwo) {
        if(step === 2) {
            // noinspection JSUnresolvedReference
            stepTwo.style.display = 'flex';
        }
        else {
            // noinspection JSUnresolvedReference
            stepTwo.style.display = 'none';
        }
    }

    if(stepThree) {
        if(step === 3) {
            // noinspection JSUnresolvedReference
            stepThree.style.display = 'flex';

        }
        else {
            // noinspection JSUnresolvedReference
            stepThree.style.display = 'none';
        }
    }
}

let isMenuMobileReady = false;
async function prepareMenuMobile() {
    if(!isMenuMobileReady) {
        console.log('prepare menu');

        const userInfo = window.localStorage ?
            JSON.parse(window.localStorage.getItem('user-info')) : false;

        // noinspection JSUnresolvedReference
        if(userInfo && !userInfo.isGuest)
            translate({
                str: 'Área do anunciante',
                element: document.querySelector('.menu-label-mobile'),
            });

        await prepareMenuMobileFront();

        isMenuMobileReady = true;
    }
}

function prepareMenuMobileFront() {
    const esMenuItems = Object.values(
        document.querySelectorAll('div[aria-labelledby="escortsDropdown"] .custom-menu-group:not([data-exclude])')
    );
    const trMenuItems = Object.values(
        document.querySelectorAll('div[aria-labelledby="travestisDropdown"] .custom-menu-group:not([data-exclude])')
    );

    // removing desktop h4 from opposite type so the mobile opposite menu step only have 1 level
    const selector = window.tipologia === 'travestis' ?
        'div[aria-labelledby="escortsDropdown"]' : 'div[aria-labelledby="travestisDropdown"]';
    const menuStateTitle = document.querySelector(`${selector} .custom-menu-group span.state-title`);
    if(menuStateTitle) menuStateTitle.remove();

    // Fill menu step
    esMenuItems.forEach(async (menuItem) =>
        await fillMenuMobile(menuItem, '.menu-step[data-step="2"] ul'));

    trMenuItems.forEach(async (menuItem) =>
        await fillMenuMobile(menuItem, '.menu-step[data-step="3"] ul'));
}

async function fillMenuMobile(item, container) {
    const currentContainer = document.querySelector(container);
    const spanStateTitle = item.querySelector('span.state-title');
    if(!spanStateTitle) {
        // OppositeCase *1
        const firstStepContainer = document.querySelector('.menu-step[data-step="1"]');

        const firstBtn = firstStepContainer.querySelector('ul li:nth-child('+ (window.tipologia === 'acompanhantes' ? 2 : 1) +')');
        if((window.homePage || isFavoritesPage) && firstBtn) {
            firstBtn.onclick = () => window.location.href = getHomeUrl(true);
            firstBtn.querySelector('.icon-menu-arrow-white').remove();
        }
        else {
            const option = item.querySelector('.custom-dropdown-item li');
            if(!option) return false;

            currentContainer.appendChild(option);
            await insertMasCidadesMenuStep(currentContainer);
        }

        if(window.tipologia === 'travestis') firstBtn.parentElement.appendChild(firstBtn);
    } else {
        // DefaultCase
        const title = spanStateTitle.innerHTML;
        const cityOptions = item.querySelectorAll('li:not(.area-item)');
        const stateId = spanStateTitle ? spanStateTitle.getAttribute('data-id') : null;

        let mobileMenuItem = document.createElement('li');
        let arrowIcon = document.createElement('span');
        arrowIcon.classList.add('icon-menu-arrow-gray');

        let cities = [];
        cityOptions.forEach(cityOption => {
            let city = {};
            city.ciudad_nombre = cityOption.querySelector('a').innerHTML.trim();
            city.path = cityOption.querySelector('a').href.replace(window.HTML_ROOT + '/', '');
            city.className = cityOption.hasAttribute('class') ? cityOption.getAttribute('class') : '';
            city.order = cityOption.hasAttribute('data-mobile-order') ? cityOption.getAttribute('data-mobile-order') : '';
            city.areas = [];

            cityOption.querySelectorAll('li.area-item').forEach(areaOption => {
                let area = {};
                area.area_nombre = areaOption.querySelector('a').innerHTML.trim();
                area.path = areaOption.querySelector('a').href.replace(window.HTML_ROOT + '/', '');
                area.className = areaOption.hasAttribute('class') ? areaOption.getAttribute('class') : '';
                area.order = areaOption.hasAttribute('data-mobile-order') ? areaOption.getAttribute('data-mobile-order') : '';

                city.areas.push(area);
            });

            cities.push(city);
        });

        mobileMenuItem.innerHTML = title;
        mobileMenuItem.style.order = item.getAttribute('data-mobile-order');
        mobileMenuItem.appendChild(arrowIcon);

        mobileMenuItem.addEventListener('click', () =>
            loadMenuStep(cities, stateId, title,  2)
        );

        currentContainer.appendChild(mobileMenuItem);
    }
}

export function initUserInfo() {
    const userInfo = window.localStorage ? JSON.parse(window.localStorage.getItem('user-info')) : false;
    if(!userInfo)
        loadUserInfo();
    else
        renderUserInfo(userInfo, isMobileDevice);
}

function loadUserInfo(onlyData) {
    const formData = new FormData();
    formData.append('isMobile', isMobileDevice);

    fetch(`${window.privadaUrl}user-info`, {
        method: 'POST',
        mode: 'cors',
        credentials: "include",
        body: formData,
    }).then(response => response.json().then(data => renderUserInfo(data, isMobileDevice, onlyData)));
}

async function renderUserInfo(data, isMobileDevice, onlyData = false) {
    window.localStorage.setItem('user-info', JSON.stringify(data));

    if(onlyData) return false;

    const selector = !isMobileDevice ? '#user-info.desktop' : '#user-info-mobile';

    // noinspection JSUnresolvedReference
    if(data.isGuest) return false;

    const ddHeader = document.querySelector(`${selector} .myaccount-dropdown-header`);
    document.querySelector(`${selector} .icon-user-filled`).classList.remove('d-none');

    if(!isMobileDevice && ddHeader) { // noinspection JSUnresolvedReference
        ddHeader.innerHTML = `
            <span class="text-bold">${translate({str: 'Olá {name}', params: {name: data.name}})}</span>
            <span>|</span>
            <a onclick="clearLoginSession();" href="${window.HTML_ROOT}/logout">${translate({str: 'Fechar'})}</a>
            <button type="button" id="myaccount-dropdown-close" aria-label="Cerrar">
                <span class="icon-close-icon"></span>
            </button>
        `;
    }
    document.querySelector(`${selector} .icon-menu-private-icon`).classList.add('d-none');

    // noinspection JSUnresolvedReference
    if(!data.isGuest) {
        document.querySelector('.myaccount-dropdown-btn').onclick = () => {};

        document.querySelector('.myaccount-dropdown-btn .front').classList.add('d-none');
        document.querySelector('.myaccount-dropdown-btn .privada').classList.remove('d-none');

        Array.from(document.querySelectorAll('header .show-logged-in')).forEach(element => element.classList.remove('d-none'));
    }

    if(window.location.href.includes('/privada')) {
        document.querySelector('.myaccount-dropdown-btn .privada').classList.remove('d-none');
        document.querySelector('.myaccount-dropdown-btn .front').classList.add('d-none');
    }
}

export function iOS() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

window.goToUrl = goToUrl;
export function goToUrl(path, blank = false) {
    if(blank) window.open(path, '_blank');
    else window.location.href = path;
}

let hasRequestListCityLinkBlock = false;
window.checkHideListLinkBlockRequested = checkHideListLinkBlockRequested;
function checkHideListLinkBlockRequested() {
    if(hasRequestListCityLinkBlock) return;

    const formData = new FormData();
    formData.append('tipo', window.tipologia === 'acompanhantes' ? '1' : '2');
    formData.append('path', window.location.pathname.substr(1));

    fetch(`${window.HTML_ROOT}/request-list-city-link-block`, {
        method: 'POST',
        headers: {'X-Requested-With': 'XMLHttpRequest'},
        body: formData
    }).then(response => response.json().then(body => renderListCityBlockLink(body)));
}

function renderListCityBlockLink(data) {
    const container = document.querySelector('.list-area-dropdown-content ul');
    container.querySelectorAll('.list-area-dropdown-content li').forEach(li => li.remove());

    Object.keys(data).forEach(landingKey => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = window.location.origin + '/' + data[landingKey].path;
        // noinspection JSUnresolvedReference
        a.innerHTML = data[landingKey].nombre;

        // noinspection JSUnresolvedReference
        if(data[landingKey].is_capital) li.classList.add('city-capital', 'order-0', 'fw-bold');

        li.appendChild(a);
        container.appendChild(li);
    });

    hasRequestListCityLinkBlock = true;
}

window.checkLookingForBtn = checkLookingForBtn;
function checkLookingForBtn(element) {
    const buttons = document.querySelectorAll('.looking-for .btn');
    buttons.forEach(btn => {
        btn.classList.remove('active');
        const input = btn.querySelector('input');
        if(!input) return; // pushover

        input.checked = false;
    });
    element.classList.add('active');
    element.querySelector('input').checked = true;
}

export function isScrolleable(ele) {
    return ele && window.screen.height < ele.offsetHeight;
}

window.hasI18nChanged = hasI18nChanged;
function hasI18nChanged() {
    return parseInt(localStorage.getItem('i18nTs')) < window.i18nTs;
}

let i18nPendingPromise = null;
export async function downloadI18nTranslations() {
    if(!hasI18nChanged() && localStorage.getItem('i18n'))
        return;

    if (!i18nPendingPromise) {
        i18nPendingPromise = (async () => {
            try {
                const response = await fetch(`${window.HTML_ROOT}/get-i18n`, {
                    method: 'GET',
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                });
                localStorage.setItem('i18n', await response.json());
                localStorage.setItem('i18nTs', window.i18nTs);

                return true;
            } finally {
                i18nPendingPromise = null; // Reset after it completes, whether successful or not
            }
        })();
    }

    return i18nPendingPromise;
}

// noinspection JSUnresolvedReference
if(window.isProd) window.translate = translate;
export function translate(options) {
    let str = options.str;
    const params = options?.params;
    const element = options?.element;

    if(element) {
        if(element.innerHTML.length === 0) // in case the element has no text to avoid CLS or bad experience
            element.innerHTML = '------'; // makes placeholder wider
        element.classList.add('placeholder');
    }

    if(!localStorage.getItem('i18n') || hasI18nChanged()) {
        downloadI18nTranslations().then(() => {
            if(element)
                injectTranslationToElement(str, params, element);
        });
        return;
    }

    if(element) {
        injectTranslationToElement(str, params, element);
        return;
    }

    return getTranslationAndReplaceParams(str, params, element);
}

function injectTranslationToElement(str, params, element) {
    element.innerHTML = getTranslationAndReplaceParams(str, params, element);
}

function getTranslationAndReplaceParams(str, params, element) {
    str = JSON.parse(localStorage.getItem('i18n'))[str] || str;

    if (Array.isArray(params))
        str = params.reduce((a, b, i) => a.replace('{' + i + '}', b), str);
    else if (params)
        str = Object.keys(params).reduce((a, k) => a.replace('{' + k + '}', params[k]), str);

    if(element)
        setTimeout(() => element.classList.remove('placeholder'), 0);

    return str;
}

export function toggleOnTarifasSubidaItem() {
    document.querySelectorAll('.tarifas-subida-cat-item')
        .forEach(tarifaItem => tarifaItem.classList.add('toggle-on'));
}

// noinspection DuplicatedCode
export function showToastMsg(str, timeout = 5000) {
    const toast = document.createElement('div');
    toast.className = 'toast-msg';
    toast.innerHTML = str;
    document.body.appendChild(toast);
    toast.style.display = 'block';
    setTimeout(() => toast.style.display = 'none', timeout);
}

export function showAdultBanner() {
    document.querySelector('.adult-banner').classList.add('show');
    // noinspection JSUnresolvedReference
    document.querySelector('.darkness').style.display = 'block';

    disableScroll();
}

window.confirmAdultBanner = confirmAdultBanner;
function confirmAdultBanner() {
    localStorage.setItem('is-adult', 'true');

    document.querySelector('header').classList.add('fixed');

    enableScroll();
    // noinspection JSUnresolvedReference
    document.querySelector('.darkness').style.display = 'none';

    document.querySelector('.adult-banner').classList.remove('show');

    if (isMobileDevice)
        document.body.classList.remove('remove-padding');
}

window.denyAdultBanner = denyAdultBanner;
function denyAdultBanner() {
    window.history.back();
}

export function SVGLoader() {
    document.querySelectorAll('.svg_loader')
        .forEach((el) => el.setAttribute('src', el.getAttribute('data-src')));
}

export const addFavorite = (adID) => {
    const favItems = JSON.parse(localStorage.getItem("fav_ads")) || [];
    const match = favItems.find((item) => {
        return item === adID;
    });
    if (match)
        return true;

    favItems.push(adID);
    localStorage.setItem('fav_ads', JSON.stringify(favItems));
    customGa('favoritos', 'addFavorito', adID);

    updateFavCounts();
};

let isFirstTime = true;
export const updateFavCounts = function () {
    const favAds = JSON.parse(localStorage.getItem("fav_ads"));
    const favCount = favAds ? favAds.length : [];
    if (!isFirstTime && isFavoritesPage && favCount === 0) location.reload();

    document.querySelectorAll('.fav-count').forEach(favCountEl => {
        if (favCount.length === 0) {
            // noinspection JSUnresolvedReference
            favCountEl.style.display = 'none';
        }
        else if(favCountEl) {
            // noinspection JSUnresolvedReference
            favCountEl.style.display = 'inline-block';
        }

        favCountEl.innerHTML = favCount;
    });
};

export const removeFromFavorites = function (adID) {
    const itemFavData = document.querySelectorAll(".item_fav[data-id='" + adID + "']");
    if (itemFavData.length > 0) itemFavData.forEach(itemFavData => itemFavData.remove());
    removeFavorite(adID);
    refreshFavCountSwitch(false);
};
window.removeFromFavorites = removeFromFavorites;

const removeFavorite = function (adID) {
    const favItems = JSON.parse(localStorage.getItem("fav_ads")) || [];
    for (let i = 0; i < favItems.length; i++)
        if (parseInt(favItems[i]) === parseInt(adID))
            favItems.splice(i, 1);
    localStorage.setItem('fav_ads', JSON.stringify(favItems));
    customGa('favoritos', 'removeFavorito', adID);
    updateFavCounts();
};

window.switchListType = () => {
    const switchListType = document.querySelector('#switchListType');
    const switchBtn = document.querySelector('#switchListType');
    const resultsFav = document.querySelector("#results_favorites");

    // noinspection JSUnresolvedReference
    if (!switchListType.checked) {
        switchListType.removeAttribute('checked');
        switchBtn.checked = false;
        resultsFav.classList.remove('filtered_type_2');
        resultsFav.classList.add('filtered_type_1');
        setSearchTypeValue('1');
    } else {
        switchListType.setAttribute('checked', 'checked');
        switchBtn.checked = true;
        resultsFav.classList.remove('filtered_type_1');
        resultsFav.classList.add('filtered_type_2');
        setSearchTypeValue('2');
    }
    refreshFavCountSwitch(false);
};

export const checkCalcDistances = () => {
    let lat = localStorage.getItem("position_lat");
    let long = localStorage.getItem("position_long");

    if (document.querySelector('.card-body .distance') && lat != null && long != null) calcDistanceAds(lat, long);
};

const calcDistanceAds = function (lat, long) {
    document.querySelectorAll(".card-body .distance").forEach((el) => {
        const adLat = el.getAttribute('data-latitude'),
            adLong = el.getAttribute('data-longitude');

        let curDistance = distance(lat, long, adLat, adLong, 'K');
        if (curDistance < 1) {
            curDistance = curDistance * 1000;
            curDistance = parseInt(curDistance.toString());
            curDistance = curDistance + " m";
        } else if (curDistance >= 1 && curDistance < 100) {
            curDistance = curDistance.toFixed(2).replace('.', ',') + " km";
        } else {
            curDistance = "+100 km";
        }

        el.querySelector('span').innerHTML = curDistance;
        el.classList.add('calc');
    });
};

function distance(lat1, lon1, lat2, lon2, unit) {

    if ((lat1 === lat2) && (lon1 === lon2))
        return 0;
    else {
        const radlat1 = Math.PI * lat1 / 180;
        const radlat2 = Math.PI * lat2 / 180;
        const theta = lon1 - lon2;
        const radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1)
            dist = 1;

        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit === "K")
            dist = dist * 1.609344;
        if (unit === "N")
            dist = dist * 0.8684;

        return dist;
    }
}

export function checkHasWindowGlobal() {
    try {
        window.localStorage.setItem('has-window', 'true');
    } catch(e) {
        throw Error(errorMsgs.windowNotExist);
    }
}

export const disableGeoSearch = () => {
    checkHasWindowGlobal();

    localStorage.removeItem('geosearch_active');

    localStorage.removeItem('position_lat');
    localStorage.removeItem('position_long');

    document.querySelectorAll('.Search_location_name').forEach(searchLocationName => {
        searchLocationName.setAttribute('data-geosearch', '0');
        searchLocationName.classList.remove('geo_on');
    });
    document.querySelectorAll('.Search_user_lat').forEach(element => element.value = '');
    document.querySelectorAll('.Search_user_long').forEach(element => element.value = '');
    document.querySelectorAll('.Search_geosearch').forEach(element => element.value = '');
    document.querySelectorAll('.requestLocation').forEach(element => element.classList.remove('on'));
    document.querySelectorAll('.nearby-container').forEach(element => element.classList.remove('on'));
};

const enableGeoSearch = async function (lat, long) {
    localStorage.setItem('geosearch_active', '1');

    localStorage.setItem('position_lat', lat);
    localStorage.setItem('position_long', long);

    document.querySelectorAll('.Search_user_long').forEach(element => element.value = long);
    document.querySelectorAll('.Search_user_lat').forEach(element => element.value = lat);
    document.querySelectorAll('.Search_city_id').forEach(element => element.value = '');

    document.querySelectorAll('.Search_geosearch').forEach(element => element.value = '1');

    document.querySelectorAll('.Search_city_label').forEach(element => element.value = '');
    document.querySelectorAll('.Search_location_name').forEach(element => {
        translate({str: 'Perto de mim', element: element});
        element.classList.add('geo_on');
    });
    document.querySelectorAll('.requestLocation').forEach(element => element.classList.add('on'));
    document.querySelectorAll('.nearby-container').forEach(element => element.classList.add('on'));
};

export async function getUserLocation() {
    if (navigator.geolocation) {
        document.body.style.cursor = 'wait';

        navigator.geolocation.getCurrentPosition(
            (position) => {
                document.body.style.cursor = 'default';
                enableGeoSearch(position.coords.latitude, position.coords.longitude);
                checkCalcDistances();
            },
            async (error) => {
                await downloadI18nTranslations();

                document.body.style.cursor = 'default';
                disableGeoSearch();
                let msg;
                switch (error.code) {
                    case 1:
                        msg = translate({str: 'Você não tem o local ativado ou não deu permissão ao navegador para usá-lo.'}); // No tienes la localización activada o no has dado permiso al navegador para poder utilizarla
                        break;
                    case 2:
                        msg = translate({str: 'Ocorreu um erro ao tentar localizar você.'}); // Se ha producido un error al intentar localizarte
                        break;
                    case 3:
                        msg = translate({str: 'O tempo de espera expirou para tentar localizá-lo.'}); // Se ha agotado el tiempo de espera para intentar localizarte
                        break;
                    default:
                        msg = translate({str: 'Ocorreu um erro ao tentar localizá-lo (sua localização está ativada?).'}); // Se ha producido un error al intentar localizarte (¿tienes la localización activada?)
                        break;
                }
                showToastMsg(msg);
            },
            {timeout: 10000, maximumAge: 30000}
        );
    } else {
        await downloadI18nTranslations();
        showToastMsg(translate({str: 'Your navigator does not support Geolocation.'}));
    }
}

window.bottomMarkUnmarkBtns = bottomMarkUnmarkBtns;
function bottomMarkUnmarkBtns(targets) {
    if (!targets) targets = ['filterModal', 'searchModal'];
    setTimeout(() => {
        targets.forEach((target, i) => {
            let button = document.querySelector('#bottomBar button[data-target="#' + targets[i] + '"]');
            if(button) button.classList.remove('active-stroke', 'active-fill', 'on');
        });
    }, 0);
}

export function favoriteFicha(e) {
    e.stopPropagation();
    e.preventDefault();
    console.log('fired favoriteFicha');
    const el = e.target.closest('[data-id]');
    const curAdID = el.getAttribute('data-id');
    const favIcons = document.querySelectorAll('.fav-ico[data-id="' + curAdID + '"]');

    if (favoritesFn.isFavorite(curAdID)) {
        removeFromFavorites(curAdID);
        if(favIcons) favIcons.forEach(favIcon => favIcon.classList.remove('isfav'));
        if(isFavoritesPage) window.favoritesPage.modalAd.closeModalAd();
    } else {
        addFavorite(curAdID);
        if (isMobileDevice && document.querySelector('#mainDetailsSection')) window.fichaFn.favoriteSliderTap();
        if(favIcons) favIcons.forEach(favIcon => favIcon.classList.add('isfav'));
    }
}
export function showSplashScreen(overModal = false) {
    const element = document.querySelector('.splash-screen');
    if(element) {
        if(overModal) {
            // noinspection JSUnresolvedReference
            element.style.zIndex = '999999';
        }

        // noinspection JSUnresolvedReference
        element.style.display = 'flex';
    }
}

export function hideSplashScreen() {
    const element = document.querySelector('.splash-screen');
    if(element) {
        element.removeAttribute('style');
        // noinspection JSUnresolvedReference
        element.style.display = 'none';
    }
}

export async function initFancyBox() {
    const {Fancybox} = await import('../lib/fancybox/fancybox.esm');
    Fancybox.bind('[data-fancybox="gallery"]', {
        keyboard: false,
        arrows: true,
        hash: false,
        infobar: true,
        toolbar: "auto",
        defaultType: "image",
        hideScrollbar: true,
    });
}

// noinspection JSUnusedLocalSymbols
function contactWhatsappClick() {
    customGa('formularioContacto', 'clickWhatsapp');
}

export function refreshFavCountSwitch(data) {
    let el = document.querySelector('#resultsSection');
    if(!el) return;
    if(data) {
        el = document.createElement('div');
        el.innerHTML = data;

        const result = Array.from(el.querySelectorAll('.item_fav'))
            .map(fav => fav.getAttribute('data-ficha-id'));

        localStorage.setItem("fav_ads", "[" + result.toString() + "]");
    }

    const type1 = el.querySelectorAll('.type_1');
    const type2 = el.querySelectorAll('.type_2');

    document.querySelectorAll('#loadFavoritesContent .fav-escorts-count')
        .forEach(count => count.innerHTML = '('+ type1.length +')');
    document.querySelectorAll('#loadFavoritesContent .fav-travestis-count')
        .forEach(count => count.innerHTML = '('+ type2.length +')');
}

async function handlerClickFilter(e) {
    if (e.target.classList.contains('disabled'))
        return;

    if(!window.filterManager) {
        await getFilterItems();
        window.filterManager = await import("./filters");
        window.filterManager = window.FilterManager.init(true);
    }

    let curFilter = this.getAttribute('data-filter'),
        disabledFilters = this.getAttribute('data-disable');

    if(disabledFilters) disabledFilters = disabledFilters.split(' ');

    document.querySelectorAll('.filter_btn[data-filter="' + curFilter + '"]')
        .forEach(filterBtn => {
            filterBtn.classList.toggle('filtered');

            const [icon, iconInverted] = filterBtn.querySelectorAll('[alt^="filter-icon"]');
            if(!icon || !iconInverted) return;

            if(filterBtn.classList.contains('filtered')) {
                // noinspection JSUnresolvedReference
                icon.style.display = 'none';
                // noinspection JSUnresolvedReference
                iconInverted.style.display = 'block';
            } else {
                // noinspection JSUnresolvedReference
                icon.style.display = 'block';
                // noinspection JSUnresolvedReference
                iconInverted.style.display = 'none';
            }
        });

    if (disabledFilters) {
        disabledFilters.forEach((disabledFilter) => {
            document.querySelectorAll(".filter_btn[data-filter=" + disabledFilter + "]")
                .forEach(item => item.classList.toggle('disabled'));
        });
    }

    if(this.parentElement.id === 'filterForm')
        await window.filterManager.loadAds();

    window.filterManager.updateFilterCounter();

}

export function scrollTopList() {
    const titleDescriptionSection = document.querySelector('#titleDescriptionSection');
    if (!titleDescriptionSection) return false;
    window.scrollTo({
        top: titleDescriptionSection.getBoundingClientRect().top -100,
    });
}

window.toggleShowClass = toggleShowClass;
export async function toggleShowClass(element) {
    if(!element || !element.querySelector('span'))
        return;

    const span = element.querySelector('span');
    if(element.classList.contains('show'))
        translate({str: 'Leia mais', element: span});
    else
        translate({str: 'Leia menos', element: span});

    element.classList.toggle('show');
}

window.openSearchModal = openSearchModal;
function openSearchModal() {
    const searchModal = new Modal('#searchModal');
    searchModal.show();
}

let hasFilterItemsModal = false;

function getFilterItems() {
    return new Promise((resolve) => {
        if (window.filterManager)
            return resolve();

        fetch(window.HTML_ROOT + '/ajax/get-filter-items?path=' + document.location.pathname.substring(1), {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
        }).then(response => response.text().then(body => {
            const container = document.querySelector('#filterModal .collapseFilterServices-container');
            container.innerHTML = body;

            setFilterBtnEvent();

            hasFilterItemsModal = true;
            resolve();
        }));
    });
}
export function setFilterBtnEvent() {
    document.querySelectorAll('.filter_btn:not(.filter-price):not([data-event-setted])').forEach(btn => btn.addEventListener('click', handlerClickFilter));
    document.querySelectorAll('.filter_btn').forEach(btn => btn.setAttribute('data-event-setted', 'true'));
}

window.openFilterModal = openFilterModal;
async function openFilterModal() {
    if(!hasFilterItemsModal) showSplashScreen(true);
    downloadLazyCSS();

    if(!window.filterManager) {
        await getFilterItems();
        window.filterManager = await import("./filters");
        window.filterManager = window.FilterManager.init(true);
        window.scrollTo(0, 1);
    }
    window.filterModal.show();
    hideSplashScreen();
}

function hasAcceptCallWarningTerms() {
    return new Promise((resolve) => {
        if(window.localStorage.getItem('has-accepted-call-warning-terms')) resolve();
        else showCallWarningTermsModal(resolve);
    });
}

const container = document.querySelector('#callWarningTermsModal');
const callWarningTermsModal = parseInt(bootstrapVersion[0]) > 4 ? new Modal('#callWarningTermsModal') : undefined;
function showCallWarningTermsModal(resolve) {
    container.querySelector('.accept-btn').onclick = () => {
        resolve();
        closeCallWarningTermsModal();
    };
    callWarningTermsModal.show();
    if(isMobileDevice) setTimeout(() => disableScroll(), 0);
}

window.closeCallWarningTermsModal = closeCallWarningTermsModal;
export function closeCallWarningTermsModal() {
    callWarningTermsModal.hide();
    if(isMobileDevice) setTimeout(() => enableScroll(), 500);
}

window.toggleCallWarningTermsSession = toggleCallWarningTermsSession;
export function toggleCallWarningTermsSession() {
    // noinspection JSUnresolvedReference
    if(!document.querySelector('#accept-call-warning-terms').checked) window.localStorage.removeItem('has-accepted-call-warning-terms');
    else window.localStorage.setItem('has-accepted-call-warning-terms', 'true');
}

window.showMobilePhoneOptions = showMobilePhoneOptions;
export function showMobilePhoneOptions(telLabel, tel, adId, whatsapp, whatsappMobile, hasWhatsapp) {
    if(!isMobileDevice){
        openCallListModal(telLabel, tel, whatsapp, adId);
        return false;
    }

    const container = document.createElement('div');
    container.id = "phoneCallSection";
    container.className = "fixed-bottom d-flex d-lg-none transition-off";

    if(tel) {
        const phoneIcon = '<svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g id="prefix__phone-call"><path id="prefix__Trazado_506" d="M16.071 12.29a2 2 0 00-1.452-.664 2.079 2.079 0 00-1.47.659l-1.357 1.347c-.111-.06-.223-.115-.33-.171-.155-.077-.3-.15-.426-.227A14.725 14.725 0 017.5 10.027 8.675 8.675 0 016.341 8.2c.352-.32.679-.654 1-.975l.36-.364a1.955 1.955 0 000-2.959L6.527 2.739c-.133-.132-.27-.269-.4-.406q-.392-.409-.807-.795A2.041 2.041 0 003.88.909a2.107 2.107 0 00-1.46.629l-.009.008L.95 3.013A3.123 3.123 0 00.018 5a7.459 7.459 0 00.55 3.173 18.37 18.37 0 003.286 5.457 20.2 20.2 0 006.731 5.248 10.525 10.525 0 003.78 1.111c.09 0 .185.009.271.009a3.245 3.245 0 002.479-1.06c0-.01.013-.013.017-.022a9.542 9.542 0 01.752-.774c.185-.175.374-.36.558-.552a2.124 2.124 0 00.649-1.48 2.049 2.049 0 00-.662-1.466l-2.358-2.357zm1.538 4.5c-.168.18-.34.342-.524.521a11.09 11.09 0 00-.83.856 2.075 2.075 0 01-1.615.68h-.2a9.318 9.318 0 01-3.35-1A19.07 19.07 0 014.751 12.9a17.333 17.333 0 01-3.093-5.128 6.065 6.065 0 01-.481-2.677 1.957 1.957 0 01.592-1.27l1.465-1.459a.98.98 0 01.653-.3.916.916 0 01.627.3.074.074 0 01.013.012c.262.244.511.5.773.765l.409.415 1.172 1.165a.814.814 0 010 1.326c-.124.124-.245.248-.37.367-.36.368-.7.71-1.077 1.044-.009.008-.018.013-.022.021a.869.869 0 00-.223.971l.013.039a9.361 9.361 0 001.387 2.253l.005.005a15.723 15.723 0 003.814 3.451 6.018 6.018 0 00.529.287c.154.077.3.15.425.226.017.009.034.022.051.03a.935.935 0 00.426.107.92.92 0 00.653-.3l1.469-1.45a.971.971 0 01.648-.321.877.877 0 01.619.312l.009.009 2.363 2.353a.844.844 0 010 1.339zM10.495 4.83a5.739 5.739 0 014.671 4.67.6.6 0 001.189-.2A6.937 6.937 0 0010.7 3.643a.6.6 0 00-.7.49.6.6 0 00.486.7zm9.5 3.63A10.37 10.37 0 0011.544.008a.544.544 0 00-.628.446.55.55 0 00.45.631 9.261 9.261 0 017.549 7.553.543.543 0 00.539.453.745.745 0 00.093-.008.536.536 0 00.445-.624z" data-name="Trazado 506" style="fill:#fff"></path></g></svg>';
        const telLink = document.createElement('a');
        telLink.id = "phoneCallBtn";
        telLink.className = "call-bottombar-btn me-1 ";
        telLink.href = "tel:" + tel;
        console.log(telLink.href);
        telLink.onclick = () => onClickPhoneBtnHandler(event, adId);
        telLink.innerHTML = phoneIcon + telLabel;
        container.appendChild(telLink);
    }

    if(hasWhatsapp && whatsapp) {
        const wappIcon = '<svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="21.955" height="21.92" viewBox="0 0 21.955 21.92"><defs><style>.prefix__cls-1{fill:#fff}</style></defs><g id="prefix__whatsapp-4" transform="translate(-.04 -.04)"><path id="prefix__Trazado_507" d="M.04 21.96l1.551-5.628A10.791 10.791 0 01.132 10.9 10.946 10.946 0 0118.8 3.225 10.763 10.763 0 0122 10.91a10.914 10.914 0 01-10.937 10.862 10.974 10.974 0 01-5.228-1.322zm6.06-3.477l.332.2a9.116 9.116 0 004.625 1.259 9.07 9.07 0 009.086-9.029 8.948 8.948 0 00-2.653-6.391A9.1 9.1 0 001.977 10.9a8.964 8.964 0 001.39 4.8l.216.342-.918 3.331 3.438-.9z" class="prefix__cls-1" data-name="Trazado 507"></path><path id="prefix__Trazado_508" d="M8.331 6.36c-.2-.451-.42-.46-.614-.468-.16-.007-.342-.007-.524-.007a1 1 0 00-.728.34 3.035 3.035 0 00-.956 2.264A5.272 5.272 0 006.624 11.3a11.2 11.2 0 004.666 4.1c2.307.9 2.777.724 3.278.679a2.761 2.761 0 001.843-1.29 2.259 2.259 0 00.16-1.291c-.069-.113-.251-.181-.524-.317s-1.616-.793-1.866-.883-.433-.136-.615.136-.7.883-.865 1.064-.318.2-.592.068a7.489 7.489 0 01-2.2-1.348 8.193 8.193 0 01-1.52-1.88c-.159-.271 0-.4.12-.553a8.173 8.173 0 00.691-.934.494.494 0 00-.023-.475c-.068-.136-.6-1.478-.842-2.015z" class="prefix__cls-1" data-name="Trazado 508"></path></g></svg>';
        const wappLink = document.createElement('a');
        wappLink.id = "whatsAppBtn";
        wappLink.target = "_blank";
        wappLink.className = "whatsapp-bottombar-btn ms-1 ";
        wappLink.href = isMobileDevice ? whatsappMobile : whatsapp;
        wappLink.onclick = () => onClickWhatsappBtnHandler(event, adId);
        wappLink.innerHTML = wappIcon + 'Whatsapp';
        container.appendChild(wappLink);
    }

    const section = document.createElement('section');
    section.id = "fichaContent";
    const adModal = document.querySelector('#ad_modal');
    if(adModal) {
        // noinspection JSUnresolvedReference
        adModal.style.opacity = '0';
        // noinspection JSUnresolvedReference
        adModal.style.backgroundColor = 'rgb(0 0 0 / 66%)';
        // noinspection JSUnresolvedReference
        adModal.style.transition = 'all 300ms';
        // noinspection JSUnresolvedReference
        adModal.style.display = 'block';
        // noinspection JSUnresolvedReference
        setTimeout(() => adModal.style.opacity = '1', 0);

        container.style.transition = "all 300ms";
        setTimeout(() => container.classList.remove('transition-off'), 0);

        section.appendChild(container);
        adModal.appendChild(section);

        document.addEventListener('click', () => {
            // noinspection JSUnresolvedReference
            adModal.style.opacity = '0';
            container.classList.add('transition-off');

            enableScroll();

            adModal.innerHTML = "";

            setTimeout(() => adModal.removeAttribute('style'), 300);
        }, { once: true});
    }

    disableScroll();
}

window.onClickFichaPhoneBtnHandler = onClickFichaPhoneBtnHandler;
function onClickFichaPhoneBtnHandler(event, formattedPhone, phone, fichaId) {
    event.preventDefault();
    customGa('contactoFicha', 'clickTelefono', fichaId);
    const url = event.currentTarget.href ? event.currentTarget.href : event.target.href;
    hasAcceptCallWarningTerms()
        .then(() => goToUrl(url));
}

window.onClickFichaWhatsappBtnHandler = onClickFichaWhatsappBtnHandler;
function onClickFichaWhatsappBtnHandler(event, fichaId) {
    event.preventDefault();
    const element = event.currentTarget.href ? event.currentTarget : event.target;
    const url = isMobileDevice ? element.getAttribute('data-mobile-href') : element.href;

    hasAcceptCallWarningTerms()
        .then(() => goToUrl(url, !isMobileDevice));
    customGa('contactoFicha', 'clickWhatsapp', fichaId);
}

function onClickPhoneBtnHandler(event, fichaId) {
    event.preventDefault();
    closeCallListModal();
    const url = event.currentTarget.href ? event.currentTarget.href : event.target.href;
    hasAcceptCallWarningTerms()
        .then(() => goToUrl(url));
    customGa('contactoFicha', 'clickTelefonoListado', fichaId);
}

function onClickWhatsappBtnHandler(event, fichaId) {
    event.preventDefault();
    closeCallListModal();
    const url = event.currentTarget.href ? event.currentTarget.href : event.target.href;
    hasAcceptCallWarningTerms()
        .then(() => goToUrl(url, !isMobileDevice));
    customGa('contactoFicha', 'clickWhatsappListado', fichaId);
}

window.redirectLastVisitedLanding = redirectLastVisitedLanding;
function redirectLastVisitedLanding() {
    const url = window.localStorage ? window.localStorage.getItem('last_landing_visited') : false;
    window.location.href = url && url !== "" ? window.HTML_ROOT + '/' + url : window.HTML_ROOT;
}

let lastPageOffsetY = 0;
function disableScroll() {
    lastPageOffsetY = window.pageYOffset;

    document.body.style.overflow = 'hidden';
    document.body.style.top = '-' + lastPageOffsetY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
}

function enableScroll() {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    window.scrollTo(0, lastPageOffsetY);
}

const callListModal = parseInt(bootstrapVersion[0]) > 4 ? new Modal('#callListModal') : undefined;
function openCallListModal(telLabel, tel, whatsapp, adId) {
    const phoneCallBtn = document.querySelector('#callListModal #phoneCallBtn');
    const whatsAppBtn = document.querySelector('#callListModal #whatsAppBtn');

    document.querySelector('#callListModal .phone-big').innerHTML = telLabel;
    phoneCallBtn.href = 'callto:' + tel;
    whatsAppBtn.href = whatsapp;

    phoneCallBtn.onclick = () => onClickPhoneBtnHandler(event, adId);
    whatsAppBtn.onclick = () => onClickWhatsappBtnHandler(event, adId);

    callListModal.show();
}

window.closeCallListModal = closeCallListModal;
export function closeCallListModal() {
    callListModal.hide();
}

window.mobileToggleGeolocation = mobileToggleGeolocation;
async function mobileToggleGeolocation() {
    if(!localStorage.getItem('geosearch_active')) await getUserLocation();
    else disableGeoSearch();
}

window.renderedFichaCloseBtn = renderedFichaCloseBtn;
function renderedFichaCloseBtn(event) {
    event.preventDefault();
    if(supportsHistoryState) window.history.back(-1);
}

window.copyToClipboard = ()=> {
    window.fichaFn.settingsModal.hide();

    const element = document.createElement('input');
    element.value = window.location.href;
    element.style.position = 'fixed';
    element.style.top = '0px';
    element.style.left = '0px';

    document.body.appendChild(element);

    element.select();
    element.setSelectionRange(0, 99999);

    document.execCommand('copy');

    element.remove();
};

export function isValidEmail(value) {
    return /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
}

let boostAdFrontRequesting = false;
window.boostAdFront = boostAdFront;
function boostAdFront(event) {
    event.preventDefault();
    const fichaId = document.querySelector("#boostAdEmailInput").getAttribute('data-ad-id');

    if(boostAdFrontRequesting) return false;

    boostAdFrontRequesting = true;

    const formData = new FormData();
    formData.append('ficha_id', fichaId);
    // noinspection JSUnresolvedReference
    formData.append('email', document.querySelector('#boostAdEmailInput').value);

    fetch(`${window.HTML_ROOT}/boost-ad-front`, {
        method: 'POST',
        body: formData
    }).then(response => response.json()
        .then(res => {
            const formGrp = document.querySelector('.boost-form-group');
            const input = document.querySelector('#boostAdEmailInputError');

            boostAdFrontRequesting = false;

            if(res.success === 0) {
                formGrp.classList.add('error');
                if(res.errors.hasOwnProperty('email')) input.innerHTML = res.errors.email;
                else if(res.errors.hasOwnProperty('user')) input.innerHTML = res.errors.user;
            }
            else if(res.success === 1) {
                formGrp.classList.remove('error');
                input.innerHTML = "";

                customGa('boost', 'activarBoost', fichaId);
                boostAdChangeStep(2);
            }
            else if(res.success === -1) {
                formGrp.classList.remove('error');
                input.innerHTML = "";

                const countdown = document.querySelector('.boost-countdown');
                const time = document.querySelector('.boost-time');

                if(countdown && res.hasOwnProperty('countdown')) countdown.innerHTML = res.countdown;
                if(time && res.hasOwnProperty('time')) time.innerHTML = res.time;

                boostAdChangeStep(3);
            }
        }));
}

export function boostAdChangeStep(step) {
    const steps = document.querySelectorAll('.boost-step');
    steps.forEach(item => item.classList.remove('active'));

    // recomano canviar Object.values(steps) per Array.from(steps). jj · 3/11/2020
    const item = Object.values(steps).find((item) => {
        if(item.hasAttribute('data-step') && parseInt(item.getAttribute('data-step')) === step) return item;
    });

    if (item) item.classList.add('active');
}

export function serializeArray(form) {
    const arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
        if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function (option) {
                if (!option.selected) return;
                arr.push({
                    name: field.name,
                    value: option.value
                });
            });
            return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) >-1 && !field.checked) return;
        arr.push({
            name: field.name,
            value: field.value
        });
    });
    return arr;
}

export function setSearchTypeValue(value = "") {
    document.querySelectorAll('.btn-group-toggle.looking-for .btn')
        .forEach(btn => btn.classList.remove('active'));
    const typeId = document.querySelector('[name="Search[type_id]"][type="hidden"]');

    if(typeId) {
        // noinspection JSUnresolvedReference
        value = typeId.value;
    }
    if(value === "") value = 1; // default: escorts

    const element = document.querySelector('.btn-group-toggle.looking-for input[value="' + value + '"]');

    if (element) {
        element.checked = true;
        element.parentElement.classList.add('active');
    }
}

let extraFiltersLoaded = false;
window.loadCollapsedFilters = loadCollapsedFilters;
export function loadCollapsedFilters(extraServices) {
    if(!extraFiltersLoaded) {
        document.querySelectorAll('#services .btn-group-toggle:not(.not-services) ul:not(.not-services) li')
            .forEach(li => li.remove());

        const container = document.querySelector('#services .btn-group-toggle ul:not(.not-services)');
        if(container) {
            // noinspection JSUnresolvedReference
            extraServices.forEach(extra =>
                container.innerHTML += `<li><a class="btn btn-outline-secondary btn-lg">${extra.nombre}</a></li>`
            );
        }
        extraFiltersLoaded = true;
    }
}

export function renderTooltip(x, y, text, hideScroll = true) {
    const triangleEl = document.createElement('div');
    triangleEl.className = 'custom-tooltip-triangle';
    triangleEl.innerHTML = '';

    const containerEl = document.createElement('div');
    containerEl.className = 'custom-tooltip';
    containerEl.innerHTML = text;

    containerEl.append(triangleEl);

    document.body.append(containerEl);

    containerEl.style.top = y - (containerEl.scrollHeight + 8) + "px";
    containerEl.style.left = x - (containerEl.scrollWidth / 2) + "px";

    document.addEventListener('click', () => containerEl.remove(), { once: true });

    if(hideScroll)
        document.addEventListener('scroll', () => containerEl.remove(), { once: true });

    setTimeout(() => document.body.click(), 3000);
}

window.scrollInto = scrollInto;
export function scrollInto(element) {
    if(!element) return;
    element.scrollIntoView();
}

export function setLastSearchCityLabel() {
    // noinspection JSUnresolvedReference
    const cityText = document.querySelector('.Search_location_name').value;
    window.localStorage.setItem('home_last_visited_city', cityText);
}